import React from "react";

import { motion } from "framer-motion";
import { slideIn } from "../../utils/motionVariants";

const SlideInText = ({ text, duration, delay }) => {
  return (
    <motion.p
      variants={slideIn}
      viewport={{ once: true }}
      initial="leftSlideInInitial"
      whileInView="leftSlideIn"
      transition={{
        duration,
        delay,
      }}
    >
      {text}
      <br />
    </motion.p>
  );
};

export default SlideInText;
